import Button, { ButtonTypes } from 'components/common/button';
import createReactClass from 'create-react-class';
import cx from 'classnames';
import KeyPressShortcutMixin from 'components/lib/keypress_shortcut_mixin';
import React from 'react';
import ReactDOM from 'react-dom';

import T from 'prop-types';

let AdminEditor = createReactClass({
  mixins: [new KeyPressShortcutMixin()],

  propTypes: {
    buttonOverride: T.node, // custom buttons to override standard buttons
    doesModelExist: T.bool, // whether the model exists in the binding still
    formFields: T.node.isRequired, // input fields, etc.
    onCancel: T.func.isRequired,
    onSave: T.func, // button overrides may implement saving
    saveDisabled: T.bool, // defaults to false
    saveText: T.string, // text to display in the save button; defaults to 'Save'
    title: T.string.isRequired,
  },

  getDefaultProps() {
    return {
      doesModelExist: true,
    };
  },

  componentDidMount() {
    // HACK: To autofocus correctly when there are Trix editors present, the focus needs to happen *after*
    // Trix has loaded its HTML. For some reason, Trix loading the HTML removes the cursor but keeps the
    // focus on the element.
    if (this.props.focusOn) {
      setTimeout(
        function() {
          if (this.isMounted()) {
            // eslint-disable-line react/no-is-mounted
            let node = ReactDOM.findDOMNode(this).querySelector(this.props.focusOn);
            node.focus();
            if (node.setSelectionRange) {
              let pos = node.value.length;
              node.setSelectionRange(pos, pos);
            }
          }
        }.bind(this),
        20
      );
    }
    this.registerKeyPressShortcut(['command+enter', 'ctrl+enter'], this.onSave);
    this.registerKeyPressShortcut('esc', this.onCancel);
  },

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.doesModelExist && !nextProps.doesModelExist) {
      this.props.onCancel();
    }
  },

  onCancel() {
    this.props.onCancel();
  },

  onSave() {
    if (!this.props.saveDisabled) {
      this.props.onSave();
    }
  },

  render() {
    let classes = cx('adminEditor', this.props.className);
    return (
      <div className={classes}>
        <div className="adminEditor-wrapper">
          <div className="adminEditor-topBar">
            <div className="adminEditor-title">{this.props.title}</div>
            <div className="adminEditor-close" onClick={this.onCancel} />
          </div>
          <div className="adminEditor-formFields">{this.props.formFields}</div>

          <div className="adminEditor-spacer" />
          <div className="adminEditor-buttonRow">{this.renderButtons()}</div>
        </div>
      </div>
    );
  },

  renderButtons() {
    if (this.props.buttonOverride) {
      return this.props.buttonOverride;
    }

    return [
      <Button
        key="adminEditor-cancelButton"
        type="button"
        className="adminEditor-button adminEditor-cancelButton"
        onClick={this.props.onCancel}
        buttonType={ButtonTypes.TEXT}
      >
        Cancel
      </Button>,

      <Button
        className="adminEditor-button adminEditor-saveButton"
        disabled={this.props.saveDisabled}
        key="adminEditor-saveButton"
        onClick={this.props.onSave}
        buttonType={ButtonTypes.PRIMARY}
      >
        {this.props.saveText || 'Save'}
      </Button>,
    ];
  },
});

export default AdminEditor;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/lib/admin_editor.jsx